<template>
  <v-main>
    <EditDialog ref="dialog" @reload="$refs.report.reload()" />
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="({ row }) => $refs.dialog.open(row.id)"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="$refs.dialog.open()">
          Novo Firmware...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { Firmware } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import EditDialog from './EditDialog.vue'
import { matchAnyLike, orderBy } from 'oderon-commons/src/utils.js'
import { brDt, brNum } from 'oderon-commons/src/formatters.js'

export default {
  pageTitle: 'Firmwares',
  components: {
    GenericReport,
    EditDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Firmwares',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        columns: [
          { t: 'ID|', d: 'id', color: '#cccccc', w: 80 },
          { t: 'Versão|', d: (x) => `0x${x.version.toString(16)}` },
          {
            t: 'Nome',
            d: 'name'
          },
          { t: 'Tamanho (bytes)|', d: 'size', f: brNum },
          { t: 'Atualizado em', d: 'updatedAt', f: brDt, w: 250 },
          { t: 'Removido em', d: 'deletedAt', f: brDt, w: 250 }
        ]
      },

      // checkboxes marcados (para desativar múltiplos)
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.checkDownload()
        }
      ]
    }
  },
  methods: {
    async fetchData({
      includeInactive,
      offset = 0,
      limit = 10,
      keywords
    } = {}) {
      let rows = await Firmware.findAll({ includeInactive })
      rows = rows.filter((x) =>
        matchAnyLike(keywords, x.name, x.version.toString(16))
      )
      rows = orderBy(rows, [['version', 'desc']])
      let count = rows.length
      rows = rows.slice(offset, offset + limit)
      return { rows, count }
    },

    async confirmDelete() {
      let len = this.selectedIds.length
      let message = `Tem certeza que deseja desativar ${len} firmwares?`
      if (len == 1) message = `Tem certeza que deseja desativar este firmware?`

      let res = await this.$confirmDelete({
        message,
        okText: 'Sim, desativar'
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await Firmware.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativado(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
